export const positionSubmenu = (submenuRef: React.RefObject<HTMLDivElement>) => (e: React.MouseEvent<HTMLElement>) => {
    const viewportWidth = document.body.clientWidth
    const contentWidth = Math.min(1200, viewportWidth)
    const leftMargin = (viewportWidth - contentWidth) / 2

    if (submenuRef.current) {
        submenuRef.current.setAttribute('style', `margin-left: 0px; transform: none;`)
        const submenuRect = submenuRef.current.getBoundingClientRect()
        const submenuLeft = submenuRect.x - leftMargin

        if (submenuLeft + submenuRect.width > contentWidth) {
            if (submenuRect.width > contentWidth) {
                // exceed viewport size
                submenuRef.current.setAttribute(
                    'style',
                    `max-width: ${contentWidth}px; margin-left: -${submenuLeft}px;`
                )
            } else {
                // overflows right
                const overflowSize = contentWidth - (submenuLeft + submenuRect.width)
                submenuRef.current.setAttribute('style', `margin-left: ${overflowSize - 20}px;`)
            }
        } else {
            if (submenuLeft < submenuRect.width / 2) {
                submenuRef.current.setAttribute(
                    'style',
                    `margin-left: ${Math.max(-submenuLeft, -submenuRect.width / 2)}px;`
                )
            } else {
                submenuRef.current.setAttribute('style', `transform: translateX(-50%); left: 50%;`)
            }
        }
    }
}
